import React from "react";
import Select from "react-select";
import "bootstrap/dist/css/bootstrap.min.css";

const DeliveryInformation = ({ transporters = [], onChange }) => {
  const options = transporters.map((item) => ({
    value: item.id,
    label: item.name || item.transporter_name
  }));

  return (
    <Select
      options={options}
      isSearchable={true}
      className="react-select-container"
      classNamePrefix="react-select"
      onChange={onChange}
      placeholder="Select Transporter"
      styles={{
        control: (base) => ({
          ...base,
          borderColor: "#000"
        })
      }}
    />
  );
};

export default DeliveryInformation;